import React from 'react';
import { ChevronDown } from 'lucide-react';
import LightEffects from './LightEffects';

const Hero = () => {
  const scrollToProducts = () => {
    const element = document.querySelector('#products');
    if (element) {
      const offset = 80;
      const elementPosition = element.offsetTop - offset;
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black">
      {/* Light Effects */}
      <LightEffects variant="beams" />
      <LightEffects variant="spotlight" />
      
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1576514129883-2f1d47a65da6"
          alt="Professional Lighting"
          className="w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-[7.6923%] text-center">
        <div className="max-w-5xl mx-auto space-y-8">
          {/* Main Logo/Brand */}
          <div className="mb-12">
            <h1 className="text-7xl md:text-8xl lg:text-9xl font-bold text-white mb-6 tracking-tight leading-none">
              LFX<span className="text-blue-500">Pro</span>
            </h1>
            <div className="h-1 w-32 bg-blue-500 mx-auto"></div>
          </div>

          {/* Tagline */}
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-semibold text-white leading-tight tracking-tight">
            Engineered for Experience
          </h2>

          {/* Subheading */}
          <p className="text-xl md:text-2xl text-white/85 font-light max-w-3xl mx-auto leading-relaxed">
            Premium Professional Lighting Solutions
            <span className="block mt-2 text-blue-400">Engineered in Germany</span>
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center pt-8">
            <button
              onClick={scrollToProducts}
              className="btn-primary px-10 py-5 text-lg font-medium bg-blue-600 text-white hover:bg-blue-700 transition-all duration-400 min-h-[64px] inline-flex items-center justify-center gap-3"
              style={{ borderRadius: '0px' }}
            >
              Explore Products
            </button>
            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                const element = document.querySelector('#contact');
                if (element) {
                  const offset = 80;
                  const elementPosition = element.offsetTop - offset;
                  window.scrollTo({ top: elementPosition, behavior: 'smooth' });
                }
              }}
              className="btn-secondary px-10 py-5 text-lg font-medium bg-white/10 text-white hover:bg-white hover:text-black transition-all duration-400 min-h-[64px] inline-flex items-center justify-center gap-3 border border-white/30"
              style={{ borderRadius: '0px' }}
            >
              Contact Us
            </a>
          </div>

          {/* Scroll Indicator */}
          <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 animate-bounce">
            <ChevronDown size={40} className="text-white/60" />
          </div>
        </div>
      </div>

      {/* Decorative Grid Overlay */}
      <div
        className="absolute inset-0 z-0 pointer-events-none"
        style={{
          backgroundImage:
            'repeating-linear-gradient(0deg, transparent, transparent 1px, transparent 1px, transparent 7.6923%), repeating-linear-gradient(-90deg, rgba(255,255,255,0.03), rgba(255,255,255,0.03) 1px, transparent 1px, transparent 7.6923%)',
          backgroundSize: '100% 100%',
          opacity: 0.3
        }}
      ></div>
    </section>
  );
};

export default Hero;
